import { PspPaymentOptionType } from '@bp/shared/models/business';
import type { DTO } from '@bp/shared/models/metadata';

import { BridgerPspPaymentOptionBaseSummary } from './bridger-psp-payment-option-base-summary';

export class BridgerPspPaymentOptionCryptoSummary extends BridgerPspPaymentOptionBaseSummary {

	static override readonly type = PspPaymentOptionType.crypto;

	readonly type = BridgerPspPaymentOptionCryptoSummary.type;

	constructor(dto: DTO<BridgerPspPaymentOptionCryptoSummary>) {
		super(dto);
	}

}
